<div matDialogTitle>{{ title }}</div>
<mat-dialog-content>{{ text }}</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="ok()" i18n>OK</button>
</mat-dialog-actions>
